'use strict'

// import $ from 'zepto'
// import util from 'util'
import { EventEmitter } from 'events'
import { load_image } from './lib/load.js'
// import assets from 'assets'


const DEFAULT_OPITONS = {
  threshold: 400,
  attr: 'datalazy',
  isAnimation: true,
  isSlider: false,
  timeout: 1000,
  debounce: 50,
  loadFun: null
}

// const defaultImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXCwsK592mkAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==`
const defaultImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII=`
const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
let windowFlag = true

export function lazyload(options = {}) {
  options.threshold = options.threshold || DEFAULT_OPITONS.threshold
  options.attr = options.attr || DEFAULT_OPITONS.attr
  options.timeout = options.timeout || DEFAULT_OPITONS.timeout
  options.isAnimation = options.isAnimation || DEFAULT_OPITONS.isAnimation
  options.isSlider = options.isSlider || DEFAULT_OPITONS.isSlider
  options.debounce = options.debounce || DEFAULT_OPITONS.debounce

  if(!options.container) {
    options.container = window
  } else {
    windowFlag = false
    // options.container = document.querySelector(options.container)
    options.container = container
  }

  return new LazyImage(options)
}

export function getDefaultImage () {
  return defaultImage
}

class LazyImage extends EventEmitter {
  constructor(options) {
    // code
    super()

    this.options = options
    this.nodes = []
    if(document.body) {
      this.bodyDom = document.body
    }
    if(document.documentElement) {
      this.documentDom = document.documentElement
    }
    // this.bodyDom = document.documentElement || document.querySelector("body")
    // this._check = this._check.bind(this)
    this._check = debounce(this._check.bind(this), this.options.debounce)

    this._bind()

    let images = null
    try {
      // if(!selector) {
        images = document.querySelectorAll("img[datalazy]")
      // } else {
      //   images = document.querySelectorAll(selector)
      // }
    } catch(e) {}

    if (images && images.length > 0) {
      this.add(images)
    }

  }

  _bind () {
    this.options.container.addEventListener('scroll', this._check)
    this.options.container.addEventListener('resize', this._check)
  }

  add (images) {
    // const eles = images
    const eles = Array.from(images)
    // console.log(eles)
    eles.forEach((ele) => {
      let eleNode = ele
      // console.log(eleNode.getAttribute("defaultimg"))
      eleNode.getAttribute('src') || eleNode.setAttribute('src', (eleNode.getAttribute("defaultimg") || defaultImage))
      // console.log(this.nodes)
      this.nodes.push(eleNode)
    })

    setTimeout(() => {
      this._check()
    })

    return this

  }

  _check () {
    // console.log("_check function")

    clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    let top = 0
    let container = this.options.container
    if(this.options.isSlider) {
      // top = this.options.container.height() + this.options.container.offset().top
      if(windowFlag) {
        top = clientHeight + (this.bodyDom.scrollTop || this.documentDom.scrollTop)
      } else {
        top = container.offsetHeight + container.scrollTop + container.offsetTop
      }
    } else {
      if(windowFlag) {
        top = clientHeight + (this.bodyDom.scrollTop || this.documentDom.scrollTop)
      } else {
        if(container.offsetHeight < clientHeight) {
          top = container.offsetHeight + container.scrollTop + container.offsetTop
        } else {
          top = clientHeight + container.scrollTop + container.offsetTop
        }
      }
      // if(container.offsetHeight < clientHeight) {
      //   // top = this.options.container.height() + this.options.container.scrollTop()
      // } else {
      //   // top = $(window).height() + this.options.container.scrollTop()
      // }
    }

    let nodes = this.nodes
    this.nodes = nodes.filter(node => {
      // console.log(node)
      if (!this._in_viewport(node, top)) {
        return true
      }

      let count = this.listenerCount('show')
      if (count > 0) {
        this.emit('show', node[0])
        return
      }

      this._reveal(node)
    })
  }

  _in_viewport (node, top) {
    // console.log(node.offsetTop - this.options.threshold, "offset top")
    // console.log(top, "top")
    // return node.offset().top - this.options.threshold < top
    return node.offsetTop - this.options.threshold < top
  }

  _reveal (node) {
    node.getAttribute('src') || node.setAttribute('src', (node.getAttribute("defaultimg") || defaultImage))
    let source = node.getAttribute(this.options.attr)
    let loaded = false
    if(source) {
      let url = ''
      let tm = setTimeout(() => {
        loaded = true
        this._dealImg(node, source)
      }, this.options.timeout)

      load_image(source, (err, imgObj) => {
        if (loaded) {
          return
        } else {
          clearTimeout(tm)
        }
        if(err || !imgObj || imgObj.length==0) {
          url = node.getAttribute("defaultimg") || defaultImage
        } else {
          url = imgObj.src
        }

        this._dealImg(node, url)

      })
    }
  }

  _dealImg (node, url) {
    node.setAttribute('src', url)
    node.removeAttribute('datalazy')
    // hasClass(node, 'lazy') && removeClass(node, 'lazy')
    // hasClass(node, 'lazy-loaded') || addClass(node, 'lazy-loaded')

    if(this.options.isAnimation) {
      this._addAnimation(node)
    }
  }

  _addAnimation(node) {
    hasClass(node, 'lazy-fadeIn') || addClass(node, 'lazy-fadeIn')
  }


}

function hasClass(ele, cls) {
  return (' ' + ele.className + ' ').indexOf(' ' + cls + ' ') > -1
}

function addClass(ele, cls) {
  ele.classList.add(cls)
}

function removeClass(ele, cls) {
  ele.classList.remove(cls)
}


function debounce(func, wait, immediate) {
  let timeout
  let args
  let context
  let timestamp
  let result
  let later = () => {
    let last = new Date().getTime() - timestamp

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function() {
    context = this
    args = arguments
    timestamp = new Date().getTime()
    let callNow = immediate && !timeout
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}



// WEBPACK FOOTER //
// ./static/lazyload/index.js